import React from "react";
import { Location } from "../Location";
import AccommodationProfile from "../../accommodations/AccommodationProfile/AccommodationProfile";

interface Params {
  accommodationId: string;
}

export class AccommodationProfileLocation extends Location<Params> {
  constructor(accommodationId: string) {
    super({ accommodationId });
  }

  render() {
    return (
      <AccommodationProfile id={this.params.accommodationId} directUri={this.toURI()} />
    );
  }

  toURI() {
    const { accommodationId } = this.params;
    return `/accommodations/${accommodationId}`;
  }
}
